module.exports = __webpack_public_path__ + "img/chart1.ed8433db.png";